import styled, { css } from "styled-components";
import type { UscSpacingType } from "../Variables.types";
import { UscSpacingProps } from "../Variables.types";

type SpacingType = {
    m?: UscSpacingType;
    mt?: UscSpacingType;
    mb?: UscSpacingType;
    ml?: UscSpacingType;
    mr?: UscSpacingType;
    mx?: UscSpacingType;
    my?: UscSpacingType;
};

const Spacer = styled.div<{ spacing?: SpacingType }>`
    ${(props) =>
        props.spacing &&
        props.spacing.m &&
        css`
            margin: var(${UscSpacingProps[props.spacing.m]});
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.mt &&
        css`
            margin-top: var(${UscSpacingProps[props.spacing.mt]});
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.mb &&
        css`
            margin-bottom: var(${UscSpacingProps[props.spacing.mb]}) !important; /* Override Toyota CSS */
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.ml &&
        css`
            margin-inline-start: var(${UscSpacingProps[props.spacing.ml]});
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.mr &&
        css`
            margin-inline-end: var(${UscSpacingProps[props.spacing.mr]});
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.mx &&
        css`
            margin-inline: var(${UscSpacingProps[props.spacing.mx]});
        `}
    ${(props) =>
        props.spacing &&
        props.spacing.my &&
        css`
            margin-block: var(${UscSpacingProps[props.spacing.my]});
        `};
`;

export default Spacer;
